var React = require('react');

function ArrowRightShadow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#A2C7B3","d":"M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"}));
}

ArrowRightShadow.defaultProps = {"width":"14","height":"14","viewBox":"0 0 24 24"};

module.exports = ArrowRightShadow;

ArrowRightShadow.default = ArrowRightShadow;
